module.exports = __webpack_public_path__ + "static/img/swiper_01.e258ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/prebook/swiper_01.png
// module id = jLHf
// module chunks = 1